import { useMemo } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { BaseLayout } from "@newLayouts/BaseLayout";
import { additionalConfigs } from "@newLayouts/common/navi";
import { EmptyOrganizations } from "@newComponents/common/EmptyOrganizations";
import { Popup } from "@newComponents/common/system/Popup";
import { useOrganizationContext } from "@newHooks/context/organization/organization.context";
import { ArchiverRoute } from "./routes/ArchiverRoute";
import { ContactRoute } from "./routes/ContactRoute";
import { DocumentSignRoute } from "./routes/DocumentSignRoute";
import { EConsentRoute } from "./routes/EConsentRoute";
import { MyDocumentRoute } from "./routes/MyDocumentRoute";
import { TemplateRoute } from "./routes/TemplateRoute";

export const home = {
  index: "/",
} as const;

export default function NewHomeLayout() {
  const { organizations, isLoading } = useOrganizationContext();

  const currentMenu = useMemo(() => {
    return window.location.pathname.split("/")[1];
  }, []);

  const visibleMenusWithEmptyOrganization = useMemo(() => {
    return Object.entries(additionalConfigs)
      .map(([menu, config]) => (config.allowEmptyOrganization ? menu : false))
      .filter((x) => !!x);
  }, []);

  const visible = useMemo(() => {
    return visibleMenusWithEmptyOrganization.includes(currentMenu) || !!organizations.length;
  }, [visibleMenusWithEmptyOrganization, currentMenu, organizations.length]);

  return (
    <BaseLayout>
      <BaseLayout.Header />
      <BaseLayout.LeftSideBar />
      {!isLoading && (
        <BaseLayout.Main>
          {visible ? (
            <Switch>
              <Redirect exact from="/" to="/my/folders" />
              <Redirect from="/viewer" to="/my/folders" />
              <Redirect from="/composer" to="/my/folders" />
              <Route path="/my/folders" render={() => <MyDocumentRoute />} />
              <Route path="/sign" render={() => <DocumentSignRoute />} />
              <Route path="/archiver/folders" render={() => <ArchiverRoute />} />
              <Route path="/templates" render={() => <TemplateRoute />} />
              <Route path="/econsent" render={() => <EConsentRoute />} />
              <Route path="/contacts" render={() => <ContactRoute />} />
              <Redirect from="*" to="/404?r=wh" />
            </Switch>
          ) : (
            <EmptyOrganizations />
          )}
        </BaseLayout.Main>
      )}
      <Popup />
    </BaseLayout>
  );
}
